import { render, staticRenderFns } from "./barchart.vue?vue&type=template&id=c212f51e&scoped=true"
import script from "./barchart.vue?vue&type=script&lang=js"
export * from "./barchart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c212f51e",
  null
  
)

export default component.exports